var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 13.0001C12.55 13.0277 12.5276 13.05 12.5 13.05C12.4724 13.05 12.45 13.0276 12.45 13C12.45 12.9724 12.4723 12.95 12.4999 12.95C12.5132 12.95 12.526 12.9553 12.5354 12.9646C12.5447 12.974 12.55 12.9868 12.55 13.0001",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 21H8.5C5.73858 21 3.5 18.7614 3.5 16V11.2C3.50001 9.68108 4.19046 8.24453 5.37653 7.29568L9.37653 4.09568C11.2026 2.63477 13.7974 2.63477 15.6235 4.09568L19.6235 7.29568C20.8096 8.24455 21.5 9.68109 21.5 11.2V16C21.5 18.7614 19.2614 21 16.5 21Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.05 13.0001C16.05 13.0277 16.0276 13.05 16 13.05C15.9724 13.05 15.95 13.0276 15.95 13C15.95 12.9724 15.9723 12.95 15.9999 12.95C16.0132 12.95 16.026 12.9553 16.0354 12.9646C16.0447 12.974 16.05 12.9868 16.05 13.0001",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05 13.0001C9.04997 13.0277 9.02758 13.05 8.99998 13.05C8.97239 13.05 8.95001 13.0276 8.95 13C8.94999 12.9724 8.97233 12.95 8.99993 12.95C9.01321 12.95 9.02596 12.9552 9.03535 12.9646C9.04475 12.974 9.05002 12.9868 9.05 13.0001",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.79e1435513029a358e0033d32881146a.svg";
export { ForwardRef as ReactComponent };